// extracted by mini-css-extract-plugin
export default {"menuHamburguerBotao":"MenuHamburguer_menuHamburguerBotao__ffswB"};